import {
  FETCHED_PAIRS,
  FETCHED_MY_ORDERS,
  FETCHED_MAKER_MAP,
  FETCHED_MY_MAKER_MAP,
  FETCHED_MY_UNMATCHED_ORDERS,
} from '../../types';

import callBC from '../../helpers/bc'
import {fromUnit, tokenDictionary} from '../../../config';
import {deletePending, triggerEvents} from '../../ui/marketplace';
import {lowestDenom} from '../../../config';
import {unlockData} from './unlockData';
import {Decimal} from 'decimal.js';
import BN from 'bn.js'
Decimal.set({toExpPos:100})
Decimal.set({toExpNeg:-100})
const { blake2bl } = require('bc-sdk/dist/utils/crypto')

export async function getOpenOrders(dispatch,state){
  try {
    let newPairs = JSON.parse(JSON.stringify(require('../../../config').pairs))
    let orders = await retrieveOrders(state.settings.settings)
    let cleaned = cleanUpOrders(newPairs,orders,state.socket.bcHeight)
    let transfers = state.pending.transfers;
    let my_maker_map = state.orderbook.my_maker_map;
    let my_old_orders = state.orderbook.all_orders;
    dispatch({ type:FETCHED_PAIRS, payload: cleaned.pairs});
    dispatch({ type:FETCHED_MAKER_MAP, payload: cleaned.newOrders})

    let addresses = Object.keys(state.passport.nrg).map((addr)=>{return '0x'+ blake2bl(blake2bl(addr) + addr)})

    let my_orders = [];
    for(let o of cleaned.newOrders.filter(o => {return addresses.includes(o.doubleHashedBcAddress)})) {
      let index = my_maker_map[`${o.txHash}.${o.txOutputIndex}`];
      if(index && index < my_old_orders.length && my_old_orders[index].txHash == o.txHash && o.txOutputIndex == my_old_orders[index].txOutputIndex && my_old_orders[index].unlock.makerLeft <= 0 && my_old_orders[index].unlock.takerLeft <= 0){
        o = my_old_orders[index];
      }
      else {
        o.unlock = await unlockData(state.settings.settings,state.socket.latestBlock,o)
        Object.keys(state.passport.nrg).map((addr)=>{
          if('0x'+ blake2bl(blake2bl(addr) + addr) == o.doubleHashedBcAddress) o.address = addr;
        });
        let unlock = transfers[`${o.txHash}.${o.txOutputIndex}`];
        o.unlocking = unlock && unlock.type === "Unlock Collateral";
      }
      my_maker_map[`${o.txHash}.${o.txOutputIndex}`] = my_orders.length
      my_orders.push(o)
    };

    dispatch({ type:FETCHED_MY_MAKER_MAP, payload: {maker_map:my_maker_map,orders:my_orders,latestHeight: state.socket.bcHeight}})

    // dispatch({ type: FETCHED_MY_ORDERS, payload: {orders:my_orders, latestHeight: state.socket.bcHeight}});

    deletePending(my_orders,state,dispatch)

    return Promise.resolve(true)
  }
  catch(err){
    console.log({err})
  }
}

let cleanUpOrders = (pairs,orders,bcHeight) => {
  let newOrders = orders.map(o => {
    addToPairs(o,pairs,bcHeight)
    return o;
  });

  return {newOrders,pairs}
}

export const removeFromPairs = (o, pairs) => {
  let index = `${o.receivesToChain.toUpperCase()}/${o.sendsFromChain.toUpperCase()}`;
  let index2 = `${o.sendsFromChain.toUpperCase()}/${o.receivesToChain.toUpperCase()}`;
  let orders = [];
  if(o.sendsFromChain.toLowerCase() == 'nrg') orders = pairs['auction'][index].bids;
  else {
    if(pairs['bid/ask'][index])orders = pairs['bid/ask'][index].bids;
    else orders = pairs['bid/ask'][index2].asks;
  }
  for(let i = 0; i < orders.length; i++){
    let {txHash,txOutputIndex} = orders[i];
    if(txHash == o.txHash && txOutputIndex == o.txOutputIndex) orders.splice(i, 1)
  }
}

export const modifyPairs = (taker, pairs) => {
  let index = `${taker.maker.receivesToChain.toUpperCase()}/${taker.maker.sendsFromChain.toUpperCase()}`;
  let index2 = `${taker.maker.sendsFromChain.toUpperCase()}/${taker.maker.receivesToChain.toUpperCase()}`;
  let orders = [];
  if(taker.maker.sendsFromChain.toLowerCase() == 'nrg') orders = pairs['auction'][index].bids;
  else {
    if(pairs['bid/ask'][index]) orders = pairs['bid/ask'][index].bids;
    else orders = pairs['bid/ask'][index2].asks;
  }
  for(let i = 0; i < orders.length; i++){
    let o = orders[i];
    let {txHash,txOutputIndex} = o;
    if(txHash == taker.makerTxHash && txOutputIndex == taker.makerTxOutputIndex) {
      o.mempool = true;
      o.oldReceivesUnit = o.receivesUnit;
      o.oldSendsUnit = o.sendsUnit;
      o.receivesUnit = new Decimal(o.receivesUnit).sub(new Decimal(taker.receivesAmount)).toString()
      o.sendsUnit = new Decimal(o.sendsUnit).sub(new Decimal(taker.sendsAmount)).toString()
      if(pairs['bid/ask'][index] || taker.maker.sendsFromChain.toLowerCase() == 'nrg') o.amount = o.receivesUnit
      else o.amount = o.sendsUnit;
    }
  }
}

export const addToPairs = (o,pairs,bcHeight) => {
  o.receivesUnit = fromUnit(o.receivesToChain,o.receivesUnit)
  o.sendsUnit = fromUnit(o.sendsFromChain,o.sendsUnit)
  o.receives = o.receivesUnit;
  o.sends = o.sendsUnit;

  o.receivesUnit = new Decimal(o.receivesUnit).mul((new Decimal(o.collateralizedNrg).div(new Decimal(o.originalNrg)))).toString()
  o.sendsUnit = new Decimal(o.sendsUnit).mul((new Decimal(o.collateralizedNrg).div(new Decimal(o.originalNrg)))).toString()

  o.depositLeft = `in ${o.tradeHeight + o.deposit - bcHeight} Blocks`;
  o.settleLeft = `in ${o.tradeHeight + o.settlement - bcHeight} Blocks `;
  o.depositNum = o.tradeHeight + o.deposit - bcHeight;
  o.settleNum = o.tradeHeight + o.settlement - bcHeight;

  let sendsFrom = tokenDictionary[o.sendsFromChain].toUpperCase()
  let receivesTo = tokenDictionary[o.receivesToChain].toUpperCase()

  if(sendsFrom !== 'BC') o.settleLeft += ` + ${o.shiftMaker+1} ${sendsFrom} Block`;
  if(sendsFrom != receivesTo) o.settleLeft += ` + ${o.shiftTaker+1} ${receivesTo} Blocks`

  let index = `${o.receivesToChain.toUpperCase()}/${o.sendsFromChain.toUpperCase()}`;
  let index2 = `${o.sendsFromChain.toUpperCase()}/${o.receivesToChain.toUpperCase()}`;

  if(o.sendsFromChain.toLowerCase() == 'nrg'){
    o.price = new Decimal(o.sendsUnit).div(new Decimal(o.receivesUnit)).toString();
    o.amount = o.receivesUnit;
    o.a = o.receives;
    if(o.tradeHeight + o.deposit > bcHeight ) pairs['auction'][index].bids.push(o)
  }
  else {
    if(pairs['bid/ask'][index]){
      o.price = new Decimal(o.sendsUnit).div(new Decimal(o.receivesUnit)).toString();
      o.amount = o.receivesUnit;
      o.a = o.receives;
      if(o.tradeHeight + o.deposit > bcHeight ) {
        if(o.price > pairs['bid/ask'][index].highBid) pairs['bid/ask'][index].highBid = o.price;
        pairs['bid/ask'][index].bids.push(o)
      }
    }
    else {
      o.price = new Decimal(o.receivesUnit).div(new Decimal(o.sendsUnit)).toString();
      o.amount = o.sendsUnit;
      o.a = o.sends;
      if(o.tradeHeight + o.deposit > bcHeight) {
        if(o.price < pairs['bid/ask'][index2].lowAsk) pairs['bid/ask'][index2].lowAsk = o.price;
        pairs['bid/ask'][index2].asks.push(o)
      }
    }
  }
}

async function retrieveOrders(settings) {
  let data = await callBC(settings,'getUTXOLength',['maker_output',null])
  let sum = data.result.length;
  data = await callBC(settings,'getUTXOLength',['taker_callback',null])
  sum+= data.result.length;
  let orders = [];

  if(sum > 0){
    let final = sum;
    let from = 0;
    let to = final < 1000 ? final : 1000;
    let search = true;
    while(search){
      let data2 = await callBC(settings,'getOpenOrders',[null,from,to])
      for(let o of data2.result.ordersList){
        let mod = new Decimal(o.originalNrg).div(new Decimal(o.nrgUnit));
        if(new Decimal(o.sendsUnit).mod(mod).toString() !== '0' || new Decimal(o.receivesUnit).mod(mod).toString() !== '0'){
          o.nrgUnit = o.originalNrg;
        }
      }
      data = JSON.parse(JSON.stringify(data2))

      if(data.result && data.result.ordersList){
        orders = orders.concat(data.result.ordersList)
      }
      if(to === final) search = false;
      from = to + 1;
      to = to + 1000 > final ? final : to + 1000;
    }
  }
  return orders;
}
